import { FLOW, IDataFlowSink } from 'app/model/adapters/dataflow/IDataflow';
import { BaseAsyncAdapter, ITridentResource } from 'shell-models-lib';
import { Metamodel } from 'app/model/base/model';
import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { DataFlowSchemaAdapterUtils } from './dataflow-schema-adapter-utils';
import { IDslScriptable } from 'app/model/adapters/dataflow/transformations/base-transformation.adapter';
import { DataFlowAdapterUtils } from './adapter.util';
import { OutputTransformation } from 'app/model/dataflow/outputtransformation';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(OutputTransformation),
    asynchronous: true
})
export class OutputAdapter extends BaseAsyncAdapter<OutputTransformation, IDataFlowSink> implements IDslScriptable {
    public async getDslScript(model: OutputTransformation): Promise<string> {
        const props: string[] = [DataFlowSchemaAdapterUtils.getColumnsDsl(model)];
        const inputStreams: string = model.inputStreams.map((inputStream) => inputStream.qualifiedName).join(', ');

        const knownProps = props.filter((prop) => !!prop).join(',\n\t');
        const unknownProps = DataFlowAdapterUtils.getUnknownProps(model, knownProps);
        const transformationData = [knownProps, unknownProps].filter((c) => !!c).join(',\n\t');
        return `${inputStreams} output(${transformationData}) ${FLOW} ${model.name}`;
    }

    public getCacheStoreDSL(model: OutputTransformation): string {
        const input = DataFlowSchemaAdapterUtils.getInputDefinitionDslForColumns(model.columns);
        const store = `store: 'cache'`;
        const format = `format: 'inline'`;
        const transformationData = [input, store, format].join(',\n\t');
        return `sink(${transformationData}) ${FLOW} ${ model.name }`;
    }

    protected async _toResource(model: OutputTransformation): Promise<IDataFlowSink> {
        const resource: IDataFlowSink = {
            name: model.name,
            description: model.description
        };
        return resource;
    }

    protected async _toModel(resource: IDataFlowSink, outputTransformation?: OutputTransformation): Promise<OutputTransformation> {
        if (!outputTransformation) {
            outputTransformation = Metamodel.modelFor(OutputTransformation).create<OutputTransformation>(resource.name);
        } else {
            outputTransformation.name = resource.name;
        }
        return outputTransformation;
    }

    protected override async _toAzureResource(tridentResource: ITridentResource): Promise<never> {
        throw `Artifact type '${tridentResource.artifactType}' does not implement _toAzureResource method.`;
    }
}
